import { Box } from "@mantine/core";
import { useGetMultiplacerMediaAssetsMediaAssetKeyQuery } from "../openapi";
import { MEDIA_ASSET_KEYS } from "@multiconsult-group/multiplacer-core";

const Testpage: React.FC = () => {
  const { data } = useGetMultiplacerMediaAssetsMediaAssetKeyQuery({
    mediaAssetKey: MEDIA_ASSET_KEYS.REVIT_PLUGIN_INSTALLER,
  });

  return <Box p={5}>{JSON.stringify(data)}</Box>;
};

export default Testpage;
